// extracted by mini-css-extract-plugin
export var underlinedLink = "_qb-0";